<template>
  <div class="bg-red-50 border-2 border-red-200 rounded-lg p-6 text-center">
    <i class="fa-solid fa-exclamation-triangle text-red-500 text-2xl mb-3"></i>
    <p class="text-red-700 font-medium mb-3">{{ message }}</p>
    <button
      @click="$emit('retry')"
      class="bg-red-500 text-white font-semibold py-2 px-4 rounded-lg transition-all duration-200 hover:bg-red-600"
    >
      Réessayer
    </button>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'

defineProps({
  message: {
    type: String,
    default: 'Une erreur est survenue.'
  }
})

defineEmits(['retry'])
</script>
